import {useMemo} from 'react';

import {LoadingPage} from 'shells/loading-page/loading-page';
import {Table} from 'shells/table/table';
import type {Column} from 'shells/table/table-types';
import type {Row} from 'shells/table/types';

import type {GetEmailSyncPotentialContacts_getEmailSyncPotentialContacts as EmailSyncFoundContact} from 'nutshell-graphql-types';

import {EmailSyncRecentContactCell} from './email-sync-recent-contact-cell';

interface Props {
    contacts: EmailSyncFoundContact[];
    isLoading: boolean;
    setSelectedContacts: (contacts: EmailSyncFoundContact[]) => void;
}

export function ContactsList(props: Props) {
    const columns = useMemo<Column<EmailSyncFoundContact>[]>(
        () => [
            {
                Header: 'Recent contacts',
                accessor: (EmailSyncFoundContact) => EmailSyncFoundContact,
                dataType: 'component',
                width: 300,
                Cell: ({cell}: {cell: {value: EmailSyncFoundContact}}) => (
                    <EmailSyncRecentContactCell contact={cell.value} />
                ),
            },
            {
                Header: 'Last contacted',
                accessor: 'lastContactedTime',
                dataType: 'timestamp',
            },
        ],
        []
    );

    if (props.isLoading) {
        return <LoadingPage />;
    }

    const handleCheck = (selectedFlatRows: Row<EmailSyncFoundContact>[]) => {
        props.setSelectedContacts(selectedFlatRows.map((row) => row.original));
    };

    return (
        <Table
            columns={columns}
            data={props.contacts}
            disableFilters={true}
            isCheckboxSelectable={true}
            defaultAllRowsChecked={true}
            onCheckedRowsChange={handleCheck}
            fullWidth={true}
        />
    );
}
